import { useMemo } from "react";
import { Box, SxProps } from "@mui/material";
import {
  UsersIcon,
  BookOpenIcon,
  WrenchScrewdriverIcon,
  BugAntIcon,
  HomeIcon,
  RectangleGroupIcon,
  PresentationChartLineIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "features/auth";
import { UserRoleEnum } from "features/users/types";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { sidebarStyle, sidebarInnerStyle, HangfireItem, buildInfoStyle } from "./styles";

export interface MenuItemProps {
  to: string;
  label: string;
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  minAccessLevel?: UserRoleEnum;
  target?: "_blank";
  styles?: SxProps;
}

const MENU_ITEMS: MenuItemProps[] = [
  { to: "/workspaces/1", label: "Workspaces", Icon: HomeIcon },
  { to: "/statistics", label: "Statistics", Icon: PresentationChartLineIcon, minAccessLevel: UserRoleEnum.Manager },
  { to: "/users", label: "Users", Icon: UsersIcon, minAccessLevel: UserRoleEnum.Manager },
  { to: "/languages", label: "Languages", Icon: BookOpenIcon, minAccessLevel: UserRoleEnum.Admin },
  { to: "/validation-rules", label: "Validation Rules", Icon: RectangleGroupIcon, minAccessLevel: UserRoleEnum.Admin },
  { to: "/data-sync", label: "Sync utils", Icon: WrenchScrewdriverIcon, minAccessLevel: UserRoleEnum.Admin },
  {
    to: `${window.appConfig.baseUrl}/hangfire`,
    label: "Hangfire",
    Icon: BugAntIcon,
    minAccessLevel: UserRoleEnum.Admin, // TODO: move to owner on release
    target: "_blank",
    styles: HangfireItem,
  },
];

export const Sidebar = () => {
  const { userRole } = useAuth();
  const items = useMemo(
    () => MENU_ITEMS.filter(item => (item.minAccessLevel ? userRole <= item.minAccessLevel : true)),
    [userRole],
  );

  return (
    <Box sx={sidebarStyle}>
      <Box sx={sidebarInnerStyle}>
        {items.map(item => (
          <SidebarMenuItem
            to={item.to}
            label={item.label}
            Icon={item.Icon}
            key={item.to}
            target={item.target}
            styles={item.styles}
          />
        ))}
      </Box>
      <Box sx={buildInfoStyle}>build: {window.appConfig.build}</Box>
    </Box>
  );
};
